var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAltpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92056 7.96176L0.581787 10.1277L2.15772 7.40472L5.24816 3.50696L7.17385 2.85156L2.92056 7.96176Z",
    fill: "#6420FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91301 11.6451L0.393311 13.9894L2.12181 11.1212L9.21055 2.15714L11.4108 1.4082L2.91301 11.6451Z",
    fill: "#6420FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87833 12.9475L1.33325 16.5087L4.03694 12.3911L13.2418 0.786257L15.5921 0L4.87833 12.9475Z",
    fill: "#6420FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6065 3.63013L6.81983 14.2345L3.23438 17.8467L5.97815 13.6775L15.6065 1.53711V3.63013Z",
    fill: "#6420FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6065 7.20658L8.73715 15.5019L6.09399 17.9993L7.94201 14.9756L15.6065 5.27539V7.20658Z",
    fill: "#6420FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6065 10.7641L12.4211 14.5978L10.0603 16.779L11.6503 14.0592L15.6065 9.05859V10.7641Z",
    fill: "#6420FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltpay);
export default __webpack_public_path__ + "static/media/altpay.be94a1a42e9e7e4365c5d6de68839ac4.svg";
export { ForwardRef as ReactComponent };